import { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "dd_cookie_consent_v1";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      const t = setTimeout(() => setVisible(true), 700);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = (mode) => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ mode, at: new Date().toISOString() }),
    );
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-3 left-3 right-3 md:bottom-5 md:left-5 md:right-5 lg:left-auto lg:right-5 lg:max-w-md z-50"
    >
      <div className="bg-white border border-sky-200 rounded-2xl shadow-2xl p-5 md:p-6">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-cyan-50 flex items-center justify-center shrink-0">
            <Cookie className="w-5 h-5 text-cyan-600" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-heading font-bold text-slate-900 text-sm md:text-base">
              Utilizăm cookies
            </h3>
            <p className="text-xs md:text-sm text-slate-600 mt-1 leading-relaxed">
              Folosim cookies pentru a-ți oferi cea mai bună experiență pe site
              (coșul de cumpărături, preferințe). Cookies-urile de analiză ne
              ajută să îmbunătățim serviciile. Vezi{" "}
              <Link
                to="/politica-cookies"
                className="text-cyan-600 underline hover:no-underline"
                onClick={() => setVisible(false)}
              >
                politica de cookies
              </Link>
              .
            </p>
            <div className="mt-4 flex flex-col sm:flex-row gap-2">
              <button
                onClick={() => accept("all")}
                data-testid="cookie-accept-all"
                className="flex-1 h-10 rounded-lg bg-cyan-600 hover:bg-cyan-700 text-white font-semibold text-sm transition-colors"
              >
                Accept toate
              </button>
              <button
                onClick={() => accept("essential")}
                data-testid="cookie-accept-essential"
                className="flex-1 h-10 rounded-lg bg-white border-2 border-slate-200 hover:border-cyan-500 text-slate-800 font-semibold text-sm transition-colors"
              >
                Doar esențiale
              </button>
            </div>
          </div>
          <button
            onClick={() => accept("essential")}
            data-testid="cookie-close"
            className="text-slate-400 hover:text-slate-600 transition-colors"
            aria-label="Închide banner"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
